"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _TextInput = _interopRequireDefault(require("./TextInput"));

var _styling = require("../../toolkit/styling");

var _validators = require("../../toolkit/forms/validators");

var _currency = require("../../toolkit/currency");

var _providers = require("../../toolkit/providers");

//
//  src/form/CurrencyInput.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 1/23/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var propDoc = {
  currencyCode: {
    required: true,
    type: "string",
    description: "Currency code of the value entered: USD, GBP, etc"
  },
  currencySymbolStyle: {
    required: false,
    defaultValue: "null",
    type: "CSSProperties | string",
    description: "Additional stylesheet for currency symbol" + "that adds or overwrites its style attributes"
  }
};
var demoProps = [{
  demoDescription: "CNY",
  placeholder: "please enter an amount",
  currencyCode: "CNY"
}, {
  demoDescription: "USD",
  placeholder: "please enter an amount",
  currencyCode: "USD"
}];
var discussion = "\n    This component wraps [`TextInput`](/lego/component/TextInput) with a validator\n    currency values.\n    ";

var CurrencyInput = function CurrencyInput(props) {
  var styles = useStylesheet();
  var validators = useValidators(props);
  var currencyCode = props.currencyCode,
      className = props.className,
      style = props.style,
      currencySymbolStyle = props.currencySymbolStyle,
      textInputProps = (0, _objectWithoutProperties2["default"])(props, ["currencyCode", "className", "style", "currencySymbolStyle"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.currencySymbol, currencySymbolStyle)
  }, (0, _currency.getCurrencySymbol)(currencyCode)), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], (0, _extends2["default"])({
    className: (0, _styling.css)(styles.input),
    type: "number",
    validators: validators
  }, textInputProps)));
};

CurrencyInput.propDoc = propDoc;
CurrencyInput.demoProps = demoProps;
CurrencyInput.discussion = discussion;

var _default = (0, _mobxReact.observer)(CurrencyInput);

exports["default"] = _default;

var useValidators = function useValidators(_ref) {
  var validators = _ref.validators;
  return [new _validators.CurrencyValidator()].concat((0, _toConsumableArray2["default"])(validators || []));
};

var useStylesheet = function useStylesheet() {
  var _useTheming = (0, _providers.useTheming)(),
      textBlack = _useTheming.theme.textBlack,
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch"
      },
      currencySymbol: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "10px 10px 10px 0px",
        opacity: 0.8,
        fontSize: 16,
        fontFamily: fonts.semibold,
        lineHeight: 1.43,
        color: textBlack,
        cursor: "pointer",
        userSelect: "none"
      },
      input: {
        flex: 1,
        border: "none",
        maxWidth: "100%"
      }
    });
  }, [textBlack, fonts.semibold]);
};